<template>
  <div class="results">
    <div class="content">
      <p class="page-title">{{ $route.name }}</p>

      <div class="card filters">
        <button
          @click="filter_time = filter_dates.all"
          :class="{ active: filter_time == filter_dates.all }"
          class="btn round-btn"
        >
          All
        </button>
        <button
          @click="filter_time = filter_dates.today"
          :class="{ active: filter_time == filter_dates.today }"
          class="btn round-btn"
        >
          Today
        </button>
        <button
          @click="filter_time = filter_dates.yesterday"
          :class="{ active: filter_time == filter_dates.yesterday }"
          class="btn round-btn"
        >
          Since Yesterday
        </button>
        <button
          @click="filter_time = filter_dates.past_2_days"
          :class="{ active: filter_time == filter_dates.past_2_days }"
          class="btn round-btn"
        >
          Past 2 Days
        </button>
        <button
          @click="filter_time = filter_dates.past_week"
          :class="{ active: filter_time == filter_dates.past_week }"
          class="btn round-btn"
        >
          Past Week
        </button>
        <div class="filter">
          <datepicker
            placeholder="Custom Date"
            v-model="custom_date.date"
            name="uniquename"
            ref="datepicker"
            :full-month-name="true"
            :disabled-dates="custom_date.disabled"
          ></datepicker>
        </div>

        <!-- <div class="filter">
            <label>Success</label>
            <div class="switch-holder">
              <switches v-model="send_email"></switches>
            </div>
          </div> -->
      </div>
      <!-- <div class="stats small">
        <div class="card">
          <p class="stat">
            {{ results.length }}
            <span>Completed Surveys</span>
          </p>
        </div>
        <div class="card">
          <p class="stat">
            {{ results.filter((r) => r.status).length }}
            <span>Passed Surveys</span>
          </p>
        </div>
        <div class="card">
          <p class="stat">
            {{ incompleted }}
            <span>Incomplete Surveys</span>
          </p>
        </div>
        <div class="card">
          <p class="stat">
            {{ results.filter((r) => !r.status).length }}
            <span>Failed Surveys</span>
          </p>
        </div>
      </div> -->
      <div class="chart_view">
        <div class="chart_container">
          <p class="stat">
            {{ results.length }}
            <span>Completed Surveys</span>
          </p>
          <div class="legend">
            <div class="key">
              <div class="color" style="background-color: #00bf6f"></div>
              <p>Pass</p>
            </div>
            <div class="key">
              <div class="color" style="background-color: #f44336"></div>
              <p>Fail</p>
            </div>
          </div>
          <div class="ct-chart ct-golden-section" id="chart2"></div>
        </div>

        <div class="chart_container">
          <p class="stat">
            {{ results.filter((r) => !r.status).length }}
            <span>Failed Surveys</span>
          </p>
          <div class="ct-chart ct-golden-section" id="chart1"></div>
        </div>
      </div>

      <div class="card">
        <p class="title">Your Reports</p>
        <table>
          <thead>
            <tr>
              <th>Name</th>
              <th>Submitted</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(item, i) in results">
              <tr
                :key="i"
                :class="{ grey: i % 2 }"
                v-if="users[item.employee_id]"
              >
                <td data-label="Name">
                  {{
                    users[item.employee_id].first_name +
                      " " +
                      users[item.employee_id].last_name
                  }}
                </td>
                <td data-label="Submitted">
                  {{ item.created_at | format_date_time }}
                </td>
                <td data-label="Status">
                  <img
                    v-if="item.status"
                    class="action clickable"
                    src="@/assets/img/check.svg"
                  />
                  <img
                    v-else
                    class="action clickable"
                    src="@/assets/img/delete.svg"
                  />
                </td>
              </tr>
            </template>
          </tbody>
        </table>
        <div class="filters">
          <button @click="inputFileToExport" class="btn round-btn">
            Export
          </button>
        </div>
        <p v-if="filter_error" class="filter_error">{{ filter_error }}</p>
      </div>
    </div>
    <popup :showPopup="showPopup">
      <template>
        <p class="title">Enter the email you will like to send this file to.</p>
        <div class="inputs survey-forms">
          <div class="input full btm-space">
            <input
              v-model="email"
              type="email"
              placeholder="Type Email Here..."
            />
            <button @click="sendCSV">Send</button>
          </div>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import Register from "@/components/Register";
import firebase from "firebase";
import Switches from "vue-switches";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Popup from "@/components/Popup.vue";
import Swal from "sweetalert2";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
const functions = fb.default.functions;

export default {
  name: "results",
  components: {
    register: Register,
    Switches,
    Datepicker,
    popup: Popup,
  },
  data() {
    return {
      show: "1",
      custom_date: {
        date: null,
        disabled: {
          from: new Date(),
        },
      },
      filter_dates: {
        all: null,
        today: moment()
          .startOf("day")
          .valueOf(),
        yesterday: moment()
          .subtract(1, "day")
          .startOf("day")
          .valueOf(),
        past_2_days: moment()
          .subtract(2, "days")
          .startOf("day")
          .valueOf(),
        past_week: moment()
          .subtract(1, "week")
          .startOf("day")
          .valueOf(),
      },
      details: null,
      client: null,
      email: null,
      results: [],
      employees: [],
      visitors: [],
      filter_error: null,
      filter_active: null,
      showPopup: false,
      downloadLink: null,
      exportCSV: functions.httpsCallable("exportReportCSV"),
      sendEmail: functions.httpsCallable("sendEmail"),
    };
  },
  computed: {
    filter_time: {
      get() {
        if (this.custom_date.date) {
          return moment(this.custom_date.date).valueOf();
        } else {
          return null;
        }
      },
      set(val) {
        if (val == null) {
          this.custom_date.date = null;
        } else {
          this.custom_date.date = new Date(val);
        }
      },
    },
    users() {
      let users = {};
      this.employees.forEach((e) => {
        users[e.id] = e;
      });
      this.visitors.forEach((v) => {
        users[v.id] = v;
      });
      return users;
    },
    completed() {
      return this.results.reduce((acc, curr) => acc + (curr.status ? 1 : 0), 0);
    },
    incompleted() {
      return this.results.reduce((acc, curr) => acc + (curr.status ? 0 : 1), 0);
    },
  },
  watch: {
    filter_time(val) {
      return this.$bind(
        "results",
        db
          .collection("user")
          .doc(auth.currentUser.uid)
          .collection("responses")
          .orderBy("created_at", "desc")
          .endAt(val || 0)
      );
    },
  },
  async created() {
    await Promise.all([
      this.$bind("client", db.collection("user").doc(auth.currentUser.uid)),
      this.$bind(
        "employees",
        db
          .collection("user")
          .doc(auth.currentUser.uid)
          .collection("employee")
      ),
      this.$bind(
        "visitors",
        db
          .collection("user")
          .doc(auth.currentUser.uid)
          .collection("visitor")
      ),
      this.$bind(
        "results",
        db
          .collection("user")
          .doc(auth.currentUser.uid)
          .collection("responses")
          .orderBy("created_at", "desc")
      ),
    ]);
  },

  mounted() {
    this.$nextTick(async () => {
      // Initialize a Line chart in the container with the ID chart1
      new Chartist.Line("#chart1", {
        labels: [1, 2, 3, 4],
        series: [[100, 120, 180, 200]],
      });

      // Initialize a Line chart in the container with the ID chart2
      new Chartist.Bar("#chart2", {
        labels: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        series: [
          [5, 4, 3, 7, 5, 10, 3, 4, 8, 10, 6, 8],
          [3, 2, 9, 5, 4, 6, 4, 6, 7, 8, 7, 4],
        ],
      });
    });
  },

  methods: {
    handleEdit(item) {
      this.$router.push(`results/${item.form_id}/${item.id}`);
    },
    newForm() {
      let id = db.collection("form").doc().id;
      this.goTo("/form/" + id);
    },
    inputFileToExport() {
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });

      let results = this.results
        .map((r) => {
          let result = {};
          if (this.users[r.employee_id]) {
            result.name = `${this.users[r.employee_id].first_name} ${
              this.users[r.employee_id].last_name
            }`;
            result.created_at = moment(r.created_at).format(
              "MM/DD/YYYY hh:mm a"
            );
            result.status = r.status ? "Approve Entry" : "Denied Entry";
          }
          return Object.keys(result).length ? result : false;
        })
        .filter((r) => r);

      this.exportCSV(results).then((res) => {
        let csvContent = res.data;
        loader.hide();
        Swal.fire({
          title: "How you want to handle this file?",
          text: "Would you like to download on your pc or send via email?",
          type: "warning",
          showCancelButton: true,
          confirmButtonText: "DOWNLOAD",
          cancelButtonText: "SEND VIA EMAIL",
        }).then((result) => {
          if (result.value) {
            csvContent = "data:text/csv;charset=utf-8," + csvContent;
            let encodedUri = encodeURI(csvContent);
            let link = document.createElement("a");
            link.setAttribute("href", csvContent);
            link.setAttribute("download", `${this.client.name}-reports.csv`);
            document.body.appendChild(link);
            link.click();
          } else if (result.dismiss == "cancel") {
            this.downloadLink = Buffer.from(csvContent).toString("base64");
            this.showPopup = true;
          }
        });
      });
    },
    sendCSV() {
      this.showPopup = false;
      let loader = this.$loading.show({
        container: null,
        canCancel: false,
      });
      this.sendEmail({
        template_name: "covid19-user-reports",
        from_email: null,
        to_email: [
          {
            email: this.email,
            type: "to",
          },
        ],
        attachments: [
          {
            type: "text/csv",
            name: `${this.client.name}-Reports.csv`,
            content: this.downloadLink,
          },
        ],
        message: null,
      }).then(() => {
        loader.hide();
        Swal.fire("Email Has Been Sent!");
      });
    },
  },
};
</script>

<style scoped lang="scss">
.stats {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  .card {
    width: 49%;
    position: relative;
    padding-top: 70px;
    transition: box-shadow 0.3s;
    cursor: pointer;
    &:hover {
      box-shadow: 0 0 15px rgba(128, 128, 128, 0.8);
    }
    img {
      position: absolute;
      z-index: 0;
      opacity: 0.1;
      height: 80%;
      right: 10%;
      top: 50%;
      transform: translateY(-50%);
    }
    .stat {
      font-size: 80px;
      color: #49c6d4;
      font-weight: 500;
      margin: 0;
      span {
        display: block;
        font-size: 16px;
        color: #132628;
        font-weight: 500;
        margin-top: -10px;
      }
    }
  }
  &.small {
    justify-content: flex-start;
    .card {
      width: auto !important;
      margin-right: 20px;
      padding-top: 30px;
      padding: 20px;
      .stat {
        font-size: 46px;
        span {
          font-size: 14px;
          margin-top: -5px;
        }
      }
    }
  }
}

.filters {
  display: flex;
  align-items: center;
  padding: 10px;
  padding-bottom: 0;
  .btn {
    margin-right: 10px;
    margin-bottom: 10px;
    transition: box-shadow 0.3s;
    &.active {
      box-shadow: 0 0 14px #6d6c6c;
      background-color: #00d97e;
    }
  }
  .filter {
    margin-right: 10px;
    margin-bottom: 10px;
    & > label {
      margin-bottom: 0;
      position: relative;
      top: 4px;
    }
  }
}

.chart_container {
  box-shadow: 0 0 8px rgba(128, 128, 128, 0.35);
  background-color: white;
  border-radius: 15px;
  padding: 30px;
  width: 49%;
}

.chart_container .stat {
  font-size: 46px;
  color: #00bf6f !important;
  display: flex;
  flex-direction: column;
  margin: 0 0 20px 0;
}

.chart_container .stat span {
  font-size: 14px;
  margin-top: -5px;
  color: #132628;
}

.chart_contatiner .ct-series-a .ct-bar {
  stroke: #00bf6f;
}

.chart_view {
  display: flex;
  margin-bottom: 20px;
  justify-content: space-between;
}

.content {
  max-width: 1800px;
}

.key p {
  margin: 0;
}

.legend {
  display: flex;
  flex-direction: column;
  margin-bottom: 15px;
}

.legend .key {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  margin-bottom: 2px;
}

.legend .key .color {
  height: 10px;
  width: 10px;
  margin-right: 7px;
}
</style>
